import { takeEvery, call, put } from 'redux-saga/effects';
import {} from '../actions/ActionTypes';
import { FETCH_HERE_LOCATION, RECEIVE_HERE_LOCATION, REQUEST_HERE_LOCATION } from '../Popularity/ActionTypes';
import { receiveHERELocation, requestHERELocation } from '../Popularity/PopularityActions';

// worker
export function* fetchHERELocationSaga({ searchText, hereToken }) {
    try {
        // axios will not work with this because it doesn't handle CORS calls
        const response = yield call(() =>
            fetch(`https://geocode.search.hereapi.com/v1/geocode?q=${searchText}`, {
                credentials: 'same-origin',
                headers: {
                    Authorization: `Bearer ${hereToken}`
                }
            })
                .then((response) => (response.ok ? response.json() : Promise.reject()))
                .then((json) => json)
        );
        yield put(receiveHERELocation(RECEIVE_HERE_LOCATION, response));
    } catch (e) {}
}

// watcher
export const mapSagas = [takeEvery(FETCH_HERE_LOCATION, fetchHERELocationSaga)];
